import { css } from "@compiled/react";
import { useIntl } from "react-intl";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { templateKeyFeaturesSectionRelayFragment$key } from "@/__generated__/templateKeyFeaturesSectionRelayFragment.graphql";

import { getIcon } from "../../template-details-page/feature-icon-map";

export type TemplateKeyFeaturesSectionProps = {
    template: templateKeyFeaturesSectionRelayFragment$key;
    isCfind3646Treatment: boolean;
};

const keyFeaturesStyles = css({
    paddingBlockStart: "32px"
});

const headingStyles = css({
    // FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#505F79",
    fontSize: ".75rem",
    fontWeight: 400,
    letterSpacing: "1px",
    marginBlockEnd: "8px"
});

const featureStyles = css({
    alignItems: "center",
    // FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#172B4D",
    display: "flex",
    height: "40px",
    paddingBlockStart: "8px"
});

const featureTextStyles = css({
    marginInlineStart: "14px"
});

const TemplateKeyFeaturesSectionFragment = graphql`
    fragment templateKeyFeaturesSectionRelayFragment on ContentPlatformTemplate {
        keyFeatures {
            name
        }
    }
`;

// TODO: will get features from template
export const TemplateKeyFeaturesSection = ({
    template,
    isCfind3646Treatment: isCfind3646Treatment
}: TemplateKeyFeaturesSectionProps) => {
    const { keyFeatures } = useFragment(
        TemplateKeyFeaturesSectionFragment,
        template
    );
    const intl = useIntl();

    // TODO: temp placeholder data for UI purposes
    const features = keyFeatures ?? [];

    const headingText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.keyFeatures.heading",
        defaultMessage: "KEY FEATURES"
    });

    return (
        !!features.length && (
            <section css={!isCfind3646Treatment && keyFeaturesStyles}>
                <h5 css={headingStyles}>{headingText}</h5>
                {features
                    .filter((feature) => feature.name != null)
                    .map((feature) => (
                        <div css={featureStyles} key={feature.name}>
                            {getIcon(feature.name ?? "")}
                            <span css={featureTextStyles}>{feature.name}</span>
                        </div>
                    ))}
            </section>
        )
    );
};

export default TemplateKeyFeaturesSection;
